import { useShallow } from 'zustand/react/shallow';

import { AffiliateStore } from './zustand';

export const useAffiliatePartner = () => {
  return AffiliateStore((state) =>
    state.allowAffiliateCommissions ? state.partner : null,
  );
};

export const useAffiliateNoticeState = () => {
  return AffiliateStore((state) => state.notice);
};

export const useAffiliateStoreActions = () => {
  return AffiliateStore(
    useShallow((state) => ({
      upsert: state.upsert,
      clean: state.clean,
      closeNotice: state.closeNotice,
      setAllowAffiliateCommissions: state.setAllowAffiliateCommissions,
    })),
  );
};
